/**
 * Configurator Module
 * 3-krokowy quiz do dopasowania produktu Camel.
 *
 * Krok 1: Wybierz format (King Size / Superline / 100's) — single select
 * Krok 2: Wybierz smak (Intensywny / Delikatny ) — single select
 *         Jeśli Superline → pokazuje wynik dla senso superline
 * Krok 3: Wybierz 3 zdjęcia z puli — multi select (max 3)
 *         Pula jest dynamiczna per format+smak (8-12 zdjęć)
 * Loader: animowany spinner 2.5s
 * Wynik:  nazwa produktu + 3D packshot (model-viewer)
 *
 * Algorytm: Vote counting — każde zdjęcie "głosuje" na produkt
 *           (przypisanie zakodowane w nazwie pliku).
 *
 * HTML attrs:
 *   [data-configurator]             — root
 *   [data-step="1|2|3|loader|result"] — kroki
 *   [data-format="king-size|superline|100"]  — kafelek formatu
 *   [data-flavor="intensywny|delikatny"] — kafelek smaku
 *   [data-product="slug"]           — przypisanie zdjęcia do produktu
 */

(function () {
    'use strict';

    var SELECTOR = '[data-configurator]';
    var LOADER_DURATION = 1800;

    // ========================================
    // PRODUCT DATABASE
    // Mapuje format+smak → lista produktów z ich stronami
    // Jeśli 1 produkt → krok 3 dekoracyjny
    // ========================================
    var PRODUCT_DB = {
        'king-size': {
            'intensywny': [
                {
                    slug: 'legend-yellow-ks',
                    name: 'Odkryj Camel Yellow KS!',
                    page: 'product-camel-legend-yellow-ks.html',
                    model: 'assets/3d/camel-legend-yellow-ks.glb',
                    desc: 'Ponadczasowa klasyka, ikona marki Camel. Kultowa kompozycja Camel American Blend o intensywnym smaku mieszanki tytoniowej.'
                },
                {
                    slug: 'legend-yellow-soft',
                    name: 'Odkryj Camel Yellow Soft!',
                    page: 'product-camel-legend-yellow-soft.html',
                    model: 'assets/3d/camel-yellow-soft.glb',
                    desc: 'Legenda o bezkompromisowym stylu w kultowym miękkim opakowaniu. Intensywna mieszanka Camel American Blend ceniona za wierność tradycji.'
                },
                {
                    slug: 'yellow-ks',
                    name: 'Odkryj Camel Yellow KS!',
                    page: 'product-camel-yellow-ks.html',
                    model: 'assets/3d/camel-yellow-ks.glb',
                    desc: 'Ponadczasowa klasyka, ikona marki Camel. Kultowa kompozycja Camel American Blend o intensywnym smaku mieszanki tytoniowej.'
                }
            ],
            'delikatny': [
                {
                    slug: 'blue-ks',
                    name: 'Odkryj Camel Blue KS!',
                    page: 'product-camel-blue-ks.html',
                    model: 'assets/3d/camel-blue-ks.glb',
                    desc: 'Ponadczasowa klasyka w delikatniejszej odsłonie. Kompozycja Camel American Blend stworzona z myślą o łagodniejszych doznaniach.'
                },
                {
                    slug: 'legend-blue-ks',
                    name: 'Odkryj Camel Legend Blue KS!',
                    page: 'product-camel-legend-blue-ks.html',
                    model: 'assets/3d/camel-legend-blue-ks.glb',
                    desc: 'Legenda w łagodnej odsłonie. Kultowa mieszanka Camel American Blend w stylu retro, stworzona z połączenia trzech odmian tytoniu: Virginia, Burley i Oriental.'
                },
                {
                    slug: 'legend-blue-soft',
                    name: 'Odkryj Camel Legend Blue Soft!',
                    page: 'product-camel-legend-blue-soft.html',
                    model: 'assets/3d/camel-blue-soft.glb',
                    desc: 'Legenda w kultowym miękkim opakowaniu. Łagodniejsza odsłona mieszanki Camel American Blend.'
                },
                {
                    slug: 'authentic-ks',
                    name: 'Odkryj Camel Authentic KS!',
                    page: 'product-camel-authentic-ks.html',
                    model: 'assets/3d/camel-authentic-ks.glb',
                    desc: 'Autentyczność w najczystszej postaci. W tym wariancie ręcznie selekcjonowane odmiany tytoniu tworzą mieszankę o bogatym aromacie.'
                }
            ]
        },
        '100': {
            'intensywny': [
                {
                    slug: 'legend-yellow-100s',
                    name: "Odkryj Camel Legend Yellow 100's",
                    page: 'product-legend-yellow-100s.html',
                    model: 'assets/3d/camel-legend-yellow-100s.glb',
                    desc: 'Legenda, która trwa dłużej. Intensywna mieszanka Camel American Blend w większym formacie.'
                }
            ],
            'delikatny': [
                {
                    slug: 'legend-blue-100',
                    name: "Odkryj Camel Legend Blue 100's!",
                    page: 'product-legend-blue-100.html',
                    model: 'assets/3d/camel-legend-blue-100s.glb',
                    desc: 'Łagodna odsłona legendy w stylu retro. Kultowa mieszanka Camel American Blend w dłuższym formacie.'
                }
            ]
        },
        'superline': {
            'superline': [
                {
                    slug: 'senso-superline',
                    name: 'Odkryj Camel Senso Superline!',
                    page: 'product-senso-superline.html',
                    model: 'assets/3d/camel-senso-superline.glb',
                    desc: 'Jedyny cienki papieros w portfolio Camela. Smukły format, szlachetna mieszanka tytoniowa i doznania stworzone dla każdego zmysłu.'
                }
            ]
        }
    };

    // ========================================
    // IMAGE DATABASE
    // Mapuje format+smak → lista zdjęć z przypisaniem do produktu
    // ========================================
    var IMAGE_DB = {
        'king-size_intensywny': [
            { src: 'king-size-intensywny-1-legend-yellow-ks.jpg', product: 'legend-yellow-ks' },
            { src: 'king-size-intensywny-2-legend-yellow-ks.jpg', product: 'legend-yellow-ks' },
            { src: 'king-size-intensywny-3-legend-yellow-ks.jpg', product: 'legend-yellow-ks' },
            { src: 'king-size-intensywny-4-legend-yellow-ks.jpg', product: 'legend-yellow-ks' },
            { src: 'king-size-intensywny-1-legend-yellow-soft.jpg', product: 'legend-yellow-soft' },
            { src: 'king-size-intensywny-2-legend-yellow-soft.jpg', product: 'legend-yellow-soft' },
            { src: 'king-size-intensywny-3-legend-yellow-soft.jpg', product: 'legend-yellow-soft' },
            { src: 'king-size-intensywny-4-legend-yellow-soft.jpg', product: 'legend-yellow-soft' },
            { src: 'king-size-intensywny-1-yellow-ks.jpg', product: 'legend-yellow-ks' },
            { src: 'king-size-intensywny-2-yellow-ks.jpg', product: 'legend-yellow-ks' },
            { src: 'king-size-intensywny-3-yellow-ks.jpg', product: 'legend-yellow-ks' },
            { src: 'king-size-intensywny-4-yellow-ks.jpg', product: 'legend-yellow-ks' },
        ],
        'king-size_delikatny': [
            { src: 'king-size-delikatny-1-blue-ks.jpg', product: 'blue-ks' },
            { src: 'king-size-delikatny-2-blue-ks.jpg', product: 'blue-ks' },
            { src: 'king-size-delikatny-3-blue-ks.jpg', product: 'blue-ks' },
            { src: 'king-size-delikatny-1-legend-blue-ks.jpg', product: 'legend-blue-ks' },
            { src: 'king-size-delikatny-2-legend-blue-ks.jpg', product: 'legend-blue-ks' },
            { src: 'king-size-delikatny-3-legend-blue-ks.jpg', product: 'legend-blue-ks' },
            { src: 'king-size-delikatny-1-legend-blue-soft.jpg', product: 'legend-blue-soft' },
            { src: 'king-size-delikatny-2-legend-blue-soft.jpg', product: 'legend-blue-soft' },
            { src: 'king-size-delikatny-3-legend-blue-soft.jpg', product: 'legend-blue-soft' },
            { src: 'king-size-delikatny-1-authentic-ks.jpg', product: 'authentic-ks' },
            { src: 'king-size-delikatny-2-authentic-ks.jpg', product: 'authentic-ks' },
            { src: 'king-size-delikatny-3-authentic-ks.jpg', product: 'authentic-ks' }
        ],
        '100_intensywny': [
            { src: '100-intensywny-1.jpg', product: 'legend-yellow-100' },
            { src: '100-intensywny-2.jpg', product: 'legend-yellow-100' },
            { src: '100-intensywny-3.jpg', product: 'legend-yellow-100' },
            { src: '100-intensywny-4.jpg', product: 'legend-yellow-100' },
            { src: '100-intensywny-5.jpg', product: 'legend-yellow-100' },
            { src: '100-intensywny-6.jpg', product: 'legend-yellow-100' },
            { src: '100-intensywny-7.jpg', product: 'legend-yellow-100' },
            { src: '100-intensywny-8.jpg', product: 'legend-yellow-100' }
        ],
        '100_delikatny': [
            { src: '100-delikatny-1.jpg', product: 'legend-blue-100' },
            { src: '100-delikatny-2.jpg', product: 'legend-blue-100' },
            { src: '100-delikatny-3.jpg', product: 'legend-blue-100' },
            { src: '100-delikatny-4.jpg', product: 'legend-blue-100' },
            { src: '100-delikatny-5.jpg', product: 'legend-blue-100' },
            { src: '100-delikatny-6.jpg', product: 'legend-blue-100' },
            { src: '100-delikatny-7.jpg', product: 'legend-blue-100' },
            { src: '100-delikatny-8.jpg', product: 'legend-blue-100' }
        ],

    };

    // ========================================
    // IMAGE BASE PATH
    // ========================================
    var IMG_BASE = 'assets/images/configurator/';

    // ========================================
    // STATE
    // ========================================
    var state = {
        step: 1,
        format: null,      // 'king-size' | 'superline' | '100'
        flavor: null,      // 'intensywny' | 'delikatny' | 'swiezy'
        selectedImages: [] // max 3 indeksów
    };

    var rootEl = null;

    // ========================================
    // DOM HELPERS
    // ========================================
    function qs(selector, parent) {
        return (parent || rootEl).querySelector(selector);
    }

    function qsa(selector, parent) {
        return (parent || rootEl).querySelectorAll(selector);
    }

    function getStep(stepId) {
        return qs('[data-step="' + stepId + '"]');
    }

    // ========================================
    // STEP NAVIGATION
    // ========================================
    function goToStep(stepId) {
        var steps = qsa('[data-step]');
        for (var i = 0; i < steps.length; i++) {
            steps[i].classList.remove('is-active');
        }

        var target = getStep(stepId);
        if (target) {
            target.classList.add('is-active');
        }

        // Show/hide header + progress based on step type
        var isQuizStep = (stepId === 1 || stepId === '1' || stepId === 2 || stepId === '2' || stepId === 3 || stepId === '3');
        var progress = qs('.configurator__progress');
        var header = qs('.configurator__header');
        if (progress) progress.style.display = isQuizStep ? '' : 'none';
        if (header) header.style.display = isQuizStep ? '' : 'none';

        // Update progress bar
        var progressFill = qs('.configurator__progress-fill');
        var progressLabel = qs('.configurator__progress-label');
        if (stepId === 1 || stepId === '1') {
            if (progressFill) progressFill.style.width = '33.33%';
            if (progressLabel) progressLabel.textContent = 'Kroki 1/3';
            state.step = 1;
        } else if (stepId === 2 || stepId === '2') {
            if (progressFill) progressFill.style.width = '66.66%';
            if (progressLabel) progressLabel.textContent = 'Kroki 2/3';
            state.step = 2;
        } else if (stepId === 3 || stepId === '3') {
            if (progressFill) progressFill.style.width = '100%';
            if (progressLabel) progressLabel.textContent = 'Kroki 3/3';
            state.step = 3;
        }
    }

    // ========================================
    // SINGLE-SELECT STEP (shared by Step 1 & 2)
    // ========================================
    function initSingleSelectStep(config) {
        var step = getStep(config.stepId);
        if (!step) return;

        var tiles = qsa('.configurator__tile[' + config.dataAttr + ']', step);
        var btn = qs('.btn', step);

        if (btn) btn.disabled = true;

        for (var i = 0; i < tiles.length; i++) {
            tiles[i].addEventListener('click', function () {
                if (this.classList.contains('is-disabled')) return;

                var value = this.getAttribute(config.dataAttr);

                // Deselect all
                for (var j = 0; j < tiles.length; j++) {
                    tiles[j].classList.remove('is-selected');
                }

                // Select this one
                this.classList.add('is-selected');
                state[config.stateKey] = value;

                // Enable button
                if (btn) btn.disabled = false;
            });
        }

        if (btn) {
            btn.addEventListener('click', function () {
                if (!state[config.stateKey]) return;
                config.onNext();
            });
        }
    }

    // ========================================
    // STEP 1: FORMAT SELECTION
    // ========================================
    function initStep1() {
        initSingleSelectStep({
            stepId: '1',
            dataAttr: 'data-format',
            stateKey: 'format',
            onNext: function () {
                if (state.format === 'superline') {
                    // Superline ma tylko 1 produkt — skip do wyniku
                    state.flavor = 'superline';
                    goToStep('loader');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    var product = PRODUCT_DB['superline']['superline'][0];
                    setTimeout(function () {
                        showResult(product);
                    }, LOADER_DURATION);
                    return;
                }
                prepareStep2();
                goToStep(2);
            }
        });
    }

    // ========================================
    // STEP 2: FLAVOR SELECTION
    // ========================================
    function prepareStep2() {
        var step = getStep('2');
        if (!step) return;

        var tiles = qsa('.configurator__tile[data-flavor]', step);

        // Show/hide Intensywny based on format
        for (var i = 0; i < tiles.length; i++) {
            var flavor = tiles[i].getAttribute('data-flavor');
            if (flavor === 'intensywny') {
                if (state.format === 'superline') {
                    tiles[i].classList.add('is-disabled');
                    tiles[i].style.display = 'none';
                } else {
                    tiles[i].classList.remove('is-disabled');
                    tiles[i].style.display = '';
                }
            }
            // Reset selection
            tiles[i].classList.remove('is-selected');
        }

        // Reset state
        state.flavor = null;
        var btn = qs('.btn', step);
        if (btn) btn.disabled = true;
    }

    function initStep2() {
        initSingleSelectStep({
            stepId: '2',
            dataAttr: 'data-flavor',
            stateKey: 'flavor',
            onNext: function () {
                prepareStep3();
                goToStep(3);
            }
        });
    }

    // ========================================
    // STEP 3: IMAGE SELECTION
    // ========================================
    function prepareStep3() {
        var step = getStep('3');
        if (!step) return;

        var grid = qs('.configurator__grid--4', step);
        if (!grid) return;

        // Clear previous images
        grid.innerHTML = '';

        // Get image pool
        var key = state.format + '_' + state.flavor;
        var images = IMAGE_DB[key];
        if (!images) return;

        // Reset state
        state.selectedImages = [];
        updateCounter(step);

        // Shuffle images for variety
        var shuffled = shuffleArray(images.slice());

        // Render tiles
        for (var i = 0; i < shuffled.length; i++) {
            var tile = createImageTile(shuffled[i], i);
            grid.appendChild(tile);
        }

        // Disable submit button
        var btn = qs('.btn', step);
        if (btn) btn.disabled = true;
    }

    function createImageTile(imageData, index) {
        var tile = document.createElement('div');
        tile.className = 'configurator__tile';
        tile.setAttribute('data-index', index);
        tile.setAttribute('data-product', imageData.product);

        var img = document.createElement('img');
        img.className = 'configurator__tile-img';
        img.src = IMG_BASE + imageData.src;
        img.alt = '';
        img.loading = 'lazy';
        tile.appendChild(img);

        var checkbox = document.createElement('div');
        checkbox.className = 'configurator__tile-checkbox';
        tile.appendChild(checkbox);

        tile.addEventListener('click', function () {
            handleImageClick(this);
        });

        return tile;
    }

    function handleImageClick(tile) {
        var step = getStep('3');
        var index = parseInt(tile.getAttribute('data-index'), 10);

        if (tile.classList.contains('is-selected')) {
            // Deselect
            tile.classList.remove('is-selected');
            state.selectedImages = state.selectedImages.filter(function (i) { return i !== index; });
        } else {
            // Check max
            if (state.selectedImages.length >= 3) return;

            // Select
            tile.classList.add('is-selected');
            state.selectedImages.push(index);
        }

        updateCounter(step);

        // Enable/disable button
        var btn = qs('.btn', step);
        if (btn) {
            btn.disabled = state.selectedImages.length !== 3;
        }
    }

    function updateCounter(step) {
        var counterValue = qs('.configurator__counter-value', step);
        if (counterValue) {
            counterValue.textContent = state.selectedImages.length + '/3';
        }
    }

    function initStep3() {
        var step = getStep('3');
        if (!step) return;

        var btn = qs('.btn', step);
        if (btn) {
            btn.addEventListener('click', function () {
                if (state.selectedImages.length !== 3) return;
                goToStep('loader');
                window.scrollTo({ top: 0, behavior: 'smooth' });
                runMatching();
            });
        }
    }

    // ========================================
    // MATCHING ALGORITHM (Vote Counting)
    // ========================================
    function runMatching() {
        var key = state.format + '_' + state.flavor;
        var images = IMAGE_DB[key];
        var products = PRODUCT_DB[state.format] && PRODUCT_DB[state.format][state.flavor];

        if (!images || !products) return;

        // Get selected tiles from the grid
        var grid = qs('.configurator__grid--4', getStep('3'));
        var tiles = grid ? qsa('.configurator__tile.is-selected', grid) : [];

        // Count votes per product
        var votes = {};
        for (var i = 0; i < tiles.length; i++) {
            var productSlug = tiles[i].getAttribute('data-product');
            if (productSlug) {
                votes[productSlug] = (votes[productSlug] || 0) + 1;
            }
        }

        // Find winner(s)
        var maxVotes = 0;
        var winners = [];

        for (var slug in votes) {
            if (votes[slug] > maxVotes) {
                maxVotes = votes[slug];
                winners = [slug];
            } else if (votes[slug] === maxVotes) {
                winners.push(slug);
            }
        }

        // If single-product pool (100's or king-size_swiezy), just take first product
        if (winners.length === 0 && products.length === 1) {
            winners = [products[0].slug];
        }

        // Tie-break: random
        var winnerSlug = winners[Math.floor(Math.random() * winners.length)];

        // Find product info
        var winnerProduct = null;
        for (var p = 0; p < products.length; p++) {
            if (products[p].slug === winnerSlug) {
                winnerProduct = products[p];
                break;
            }
        }

        // Fallback
        if (!winnerProduct) {
            winnerProduct = products[0];
        }

        // Show result after loader
        setTimeout(function () {
            showResult(winnerProduct);
        }, LOADER_DURATION);
    }

    // ========================================
    // RESULT DISPLAY
    // ========================================
    function showResult(product) {
        goToStep('result');

        var nameEl = qs('.configurator__result-product');
        if (nameEl) nameEl.innerHTML = "Mamy to!<br/>" + product.name;

        var descEl = qs('.configurator__result-desc');
        if (descEl && product.desc) {
            descEl.innerHTML = product.desc;
        }

        // Populate CTA with product name (strip "Odkryj " prefix and trailing "!")
        var ctaNameEl = qs('.configurator__result-cta-name');
        if (ctaNameEl && product.name) {
            var ctaName = product.name.replace(/^Odkryj\s*/i, '').replace(/!$/, '');
            ctaNameEl.textContent = ctaName;
        }

        var linkEl = qs('.configurator__result-link');

        // Check if limited edition mode is enabled
        var isLimitedEnabled = rootEl.hasAttribute('data-limited-enabled');
        var isBlueKs = product.slug === 'blue-ks';
        var showLimitedCarousel = isLimitedEnabled && isBlueKs;

        // Update link — limited edition goes to limited page
        if (linkEl) {
            linkEl.href = showLimitedCarousel
                ? 'product-camel-blue-ks-limited.html'
                : product.page;
        }

        // Toggle 3D viewer vs limited carousel
        var viewerSection = qs('.model-viewer-section');
        var limitedCarousel = qs('.configurator__limited-carousel');

        if (showLimitedCarousel) {
            // Hide 3D viewer, show packshot carousel
            if (viewerSection) viewerSection.style.display = 'none';
            if (limitedCarousel) {
                limitedCarousel.style.display = '';
                // Re-initialize packshot carousel (it was hidden on DOMContentLoaded)
                if (window.initPackshotCarousel) {
                    window.initPackshotCarousel();
                }
            }
        } else {
            // Show 3D viewer, hide packshot carousel
            if (limitedCarousel) limitedCarousel.style.display = 'none';
            if (viewerSection) viewerSection.style.display = '';

            // Load 3D model
            var viewerContainer = qs('.configurator__model-container');
            if (viewerContainer && product.model) {
                viewerContainer.innerHTML = '';
                var viewer = document.createElement('model-viewer');

                var viewerAttrs = {
                    'src': product.model,
                    'camera-controls': '',
                    'disable-tap': '',
                    'shadow-intensity': '1',
                    'shadow-softness': '1',
                    'touch-action': 'pan-y',
                    'tone-mapping': 'neutral',
                    'camera-orbit': '-25deg 80deg 0.3m',
                    'camera-target': '0m 0.04m 0m',
                    'min-camera-orbit': 'auto auto 0.25m',
                    'max-camera-orbit': 'auto auto 0.4m',
                    'exposure': '0.7',
                    'animation-loop': 'none',
                    'animation-crossfade-duration': '0'
                };
                for (var attr in viewerAttrs) {
                    viewer.setAttribute(attr, viewerAttrs[attr]);
                }
                viewer.style.width = '100%';
                viewer.style.height = '100%';

                // Otwórz/zamknij paczkę button
                var controls = document.createElement('div');
                controls.className = 'viewer-controls-bottom';
                var toggleBtn = document.createElement('button');
                toggleBtn.id = 'btnTogglePack';
                toggleBtn.type = 'button';
                toggleBtn.className = 'btn btn-secondary-positive';
                toggleBtn.textContent = 'Otwórz paczkę';
                controls.appendChild(toggleBtn);
                viewer.appendChild(controls);

                viewerContainer.appendChild(viewer);

                // Init pack toggle animation (shared with 3dpack.js)
                if (window.initPackToggle) {
                    window.initPackToggle(viewer, toggleBtn);
                }
            }
        }
    }

    // ========================================
    // RESTART
    // ========================================
    function initRestart() {
        var restartBtns = qsa('[data-configurator-restart]');
        for (var i = 0; i < restartBtns.length; i++) {
            restartBtns[i].addEventListener('click', function () {
                resetState();
                goToStep(1);

                // Reset step 1 selections
                var step1Tiles = qsa('.configurator__tile[data-format]');
                for (var j = 0; j < step1Tiles.length; j++) {
                    step1Tiles[j].classList.remove('is-selected');
                }
                var step1Btn = qs('.btn', getStep('1'));
                if (step1Btn) step1Btn.disabled = true;
            });
        }
    }

    function resetState() {
        state.step = 1;
        state.format = null;
        state.flavor = null;
        state.selectedImages = [];
    }

    // ========================================
    // UTILITIES
    // ========================================
    function shuffleArray(arr) {
        for (var i = arr.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var tmp = arr[i];
            arr[i] = arr[j];
            arr[j] = tmp;
        }
        return arr;
    }

    // ========================================
    // INIT
    // ========================================
    function init() {
        rootEl = document.querySelector(SELECTOR);
        if (!rootEl) return;

        initStep1();
        initStep2();
        initStep3();
        initRestart();
        goToStep(1);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
